/* ==== home-A/app.js ==== */
/* ============================================================
   HydroMax — CURRENT
   Two motion moves only: Tick and Bubble. Rise (scroll fade-in-up) and
   Waterline (the blue sweep over the hero image) were removed page-wide.
   ============================================================ */
(() => {
'use strict';
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const fmt = new Intl.NumberFormat('en-IN');

/* ---------- Tick ---------- */
function tick(el, target, dur = 1400) {
  if (reduced) { el.textContent = fmt.format(target); return; }
  const from = parseInt(String(el.textContent).replace(/[^\d-]/g, ''), 10) || 0;
  const t0 = performance.now();
  const step = (t) => {
    const p = Math.min((t - t0) / dur, 1);
    const e = 1 - Math.pow(1 - p, 4);
    el.textContent = fmt.format(Math.round(from + (target - from) * e));
    if (p < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}
const cio = new IntersectionObserver((es) => {
  es.forEach(e => { if (e.isIntersecting) { tick(e.target, +e.target.dataset.count); cio.unobserve(e.target); } });
}, { threshold: 0.6 });
document.querySelectorAll('[data-count]').forEach(el => cio.observe(el));

/* ---------- meters ---------- */
const mio = new IntersectionObserver((es) => {
  es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.querySelector('i').style.width = e.target.dataset.meter + '%';
    mio.unobserve(e.target);
  });
}, { threshold: 0.4 });
document.querySelectorAll('[data-meter]').forEach(el => mio.observe(el));

/* ---------- Bubble ---------- */
if (reduced) {
  document.querySelectorAll('.bubbles').forEach(b => b.remove());
} else {
  document.querySelectorAll('[data-bubbles]').forEach(box => {
    const n = +box.dataset.bubbles;
    const frag = document.createDocumentFragment();
    for (let i = 0; i < n; i++) {
      const b = document.createElement('i');
      const size = 4 + Math.random() * 16;
      b.style.width = b.style.height = size + 'px';
      b.style.left = (Math.random() * 100) + '%';
      b.style.animationDuration = (12 + Math.random() * 10) + 's';
      b.style.animationDelay = (-Math.random() * 22) + 's';
      b.style.setProperty('--dx', (Math.random() * 60 - 30) + 'px');
      frag.appendChild(b);
    }
    box.appendChild(frag);
  });
}

/* ---------- marquee: clone the track for a seamless loop ----------
   The logo strip is ~49 KB of inline SVG. Shipping it twice in the HTML to make
   the 50%-translate loop work would double that for no benefit, so the markup
   carries one copy and the duplicate is made here. */
document.querySelectorAll('[data-marquee]').forEach(track => {
  track.insertAdjacentHTML('beforeend', track.innerHTML);
  track.setAttribute('aria-hidden', 'true');
});

/* ---------- buy block: quantity × care plan → live total ---------- */
(() => {
  const UNIT = 16999, MAX_QTY = 9;
  const box    = document.querySelector('[data-qty]');
  const out    = document.querySelector('[data-qty-value]');
  const totals = document.querySelectorAll('[data-total]');
  /* The prepaid line under the buy button. Optional on purpose — the page is
     still whole without it, so a copy edit that drops it must not take the
     quantity stepper down with it. */
  const prepaid = document.querySelectorAll('[data-prepaid]');
  const PREPAID_OFF = 0.05;
  if (!box || !out || !totals.length) return;

  const inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
  let qty = 1;

  function planPrice() {
    const sel = document.querySelector('input[name="careplan"]:checked');
    return sel ? +sel.value : 0;
  }
  function render() {
    out.textContent = qty;
    // The plan is charged ONCE per order, not per bottle: Protega's minted
    // plan products are quantity-capped at 1 (measured 2026-08-16 — a fresh
    // mint refuses quantity 2 with a 422 on both stores' plans), so a
    // (unit + plan) x qty promise could never ring up at qty 2+. The button
    // promises exactly what the register can charge.
    const total = UNIT * qty + planPrice();
    totals.forEach(t => { t.textContent = inr.format(total); });
    /* The prepaid price follows the same total, discount included, because the
       checkout's offer is an order-level 5% — it does not stop at the bottle.
       Rounded to the rupee (the totals carry no paise either), and rounded
       DOWN so the line can only ever understate what the customer saves. */
    prepaid.forEach(p => { p.textContent = inr.format(Math.floor(total * (1 - PREPAID_OFF))); });
    box.querySelector('[data-step="-1"]').disabled = qty <= 1;
    box.querySelector('[data-step="1"]').disabled  = qty >= MAX_QTY;
  }
  box.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-step]'); if (!btn) return;
    qty = Math.min(MAX_QTY, Math.max(1, qty + (+btn.dataset.step)));
    render();
  });
  document.querySelectorAll('input[name="careplan"]').forEach(r => r.addEventListener('change', render));
  render();
})();

/* ---------- PPB comparison bars (session 1) ---------- */
const bio = new IntersectionObserver((es) => {
  es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.style.width = e.target.dataset.bar + '%';
    bio.unobserve(e.target);
  });
}, { threshold: 0.5 });
document.querySelectorAll('[data-bar]').forEach(el => bio.observe(el));

/* ---------- safety net ----------
   IntersectionObserver does not fire while the document is hidden (background
   tab, occluded pane). Without this, such a load leaves the page blank until
   the user scrolls. */
function sweepVisible() {
  const vh = innerHeight;
  document.querySelectorAll('[data-count]').forEach(el => {
    const r = el.getBoundingClientRect();
    if (el.textContent === '0' && r.top < vh && r.bottom > 0) { tick(el, +el.dataset.count); cio.unobserve(el); }
  });
  document.querySelectorAll('[data-meter]').forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.top < vh && r.bottom > 0) el.querySelector('i').style.width = el.dataset.meter + '%';
  });
  document.querySelectorAll('[data-bar]').forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.top < vh && r.bottom > 0) el.style.width = el.dataset.bar + '%';
  });
}
addEventListener('load', () => setTimeout(sweepVisible, 1200));

/* ---------- progress + active nav ---------- */
const bar = document.getElementById('progress');
/* The header now mirrors the live store, so #navlinks holds site links
   ("/", "/pages/...") rather than in-page anchors. Only "#..." hrefs are
   valid selectors — passing "/" to querySelector throws a SyntaxError and
   would take the rest of this file down with it. Filter first.
   The active-link highlight simply no-ops while no anchor links are present;
   the progress bar is independent of the nav and keeps working. */
const links = [...document.querySelectorAll('#navlinks a')].filter(a => a.getAttribute('href').startsWith('#'));
const targets = links.map(a => document.querySelector(a.getAttribute('href'))).filter(Boolean);
let ticking = false;
function onScroll() {
  const max = document.documentElement.scrollHeight - innerHeight;
  bar.style.width = (max > 0 ? (scrollY / max) * 100 : 0) + '%';
  let active = -1;
  targets.forEach((t, i) => { if (t.getBoundingClientRect().top <= 150) active = i; });
  links.forEach((a, i) => a.classList.toggle('is-active', i === active));
  sweepVisible();
  ticking = false;
}
addEventListener('scroll', () => {
  if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
}, { passive: true });
onScroll();

/* requestAnimationFrame does not run in a hidden document, so a scroll that happens
   while the tab is backgrounded leaves `ticking` latched and the progress bar and
   active nav link stale. Clear the latch and recompute on the way back in.
   Registered here, after `ticking` and `onScroll` exist. */
addEventListener('visibilitychange', () => {
  if (document.hidden) return;
  ticking = false;
  sweepVisible();
  onScroll();
});

/* ---------- mobile menu drawer ----------
   Below 1080px the desktop nav is hidden, so this is the only route to the
   store's pages. Closing is deliberately over-served — scrim, close button,
   Esc, following a link, and crossing back to desktop width — because a
   drawer you cannot dismiss traps the page. */
const drawer = document.getElementById('drawer');
const burger = document.getElementById('burger');
if (drawer && burger) {
  const desktop = matchMedia('(min-width: 1081px)');

  function openDrawer() {
    drawer.classList.add('open');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Close menu');
    /* The lock itself is CSS, gated by the drawer's own breakpoint — see
       styles.css. All this does is set the flag and hand over the scrollbar
       width so the page does not jump as the scrollbar goes. */
    const gap = innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--sbw', gap > 0 ? gap + 'px' : '0px');
    document.documentElement.classList.add('drawer-open');
    drawer.querySelector('.drawer__links a').focus();
  }

  function closeDrawer({ restoreFocus = true } = {}) {
    if (!drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Open menu');
    document.documentElement.classList.remove('drawer-open');
    /* Focus goes back to the button that opened it, not to whatever happened
       to be focused beforehand — Safari does not focus a button on click, so
       remembering the previous element strands focus on <body> there. */
    if (restoreFocus) burger.focus();
  }

  burger.addEventListener('click', () => {
    drawer.classList.contains('open') ? closeDrawer() : openDrawer();
  });
  drawer.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
    /* a link inside the drawer navigates; leave focus alone on the way out */
    else if (e.target.closest('a')) closeDrawer({ restoreFocus: false });
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  /* resizing up to desktop hides the drawer in CSS; without this the body
     would stay scroll-locked with nothing on screen explaining why */
  desktop.addEventListener('change', (e) => { if (e.matches) closeDrawer({ restoreFocus: false }); });
}

/* ---------- sticky buy bar ---------- */
const buybar = document.getElementById('buybar');
const hero = document.querySelector('.hero');
if (buybar && hero) {
  new IntersectionObserver(([e]) => buybar.classList.toggle('show', !e.isIntersecting), { threshold: 0 })
    .observe(hero);
}
})();

/* ==== home-A/band-a.js ==== */
/* ============================================================
   BAND A — shared chrome behaviour, carried from hydromax-A:
   precise anchor landings, the floating contact rail's stand-down
   at the footer, and the nav mini cart. Nothing here is page-
   specific; see hydromax-A/band-a.js for the annotated original.
   ============================================================ */
(() => {
'use strict';

/* Both selectors are Band A elements. The targets (#modes, #reviews) belong
   to Bands C and D — this reads them at click time and never styles them, so
   it cannot collide with those seats. A renamed target just falls through to
   the browser's own anchor jump. */
/* .reel__chip was the third selector here. The reel cards carry real video and
   a play button now, and the chip — which was an anchor to #buy — is gone, so
   the selector matched nothing. Dropped rather than left as a dead entry. */
const links = document.querySelectorAll('.gift[href^="#"], .hero__rating[href^="#"]');
if (!links.length) return;

/* Gap between the sticky header and the first line of the target. */
const BREATHING_ROOM = 28;

links.forEach((link) => link.addEventListener('click', (e) => {
  /* Let the browser handle anything that isn't a plain left click —
     new tab, new window, download, and so on. */
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

  const section = document.querySelector(link.getAttribute('href'));
  if (!section) return;   /* target renamed or removed — fall back to the anchor */

  /* The first real content inside the section, not the section box. */
  const anchorEl = section.querySelector('.label, h2') || section;
  const nav = document.querySelector('.nav');
  const navH = nav ? nav.getBoundingClientRect().height : 0;

  const top = anchorEl.getBoundingClientRect().top + scrollY - navH - BREATHING_ROOM;

  e.preventDefault();
  scrollTo({
    top: Math.max(0, Math.round(top)),
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  });

  /* Keep the URL shareable without letting the hash change re-trigger the
     browser's own jump to the section box. */
  history.replaceState(null, '', link.getAttribute('href'));
}));

/* ---------- floating contact rail: stand down at the footer ----------
   The rail is a shortcut to contact. The footer is already contact — links,
   socials, policies — so the shortcut stops earning its place there, and on a
   short window it would otherwise sit on top of that content.

   Reading .foot from here is deliberate: it is observed, never styled or
   edited, so this cannot collide with whoever owns the footer. If the footer
   is ever renamed the rail simply stays visible, which is the safe failure. */
const rail = document.getElementById('frail');
const foot = document.querySelector('.foot');

if (rail && foot) {
  const setGone = (gone) => rail.classList.toggle('is-gone', gone);

  const io = new IntersectionObserver(([e]) => setGone(e.isIntersecting), { threshold: 0 });
  io.observe(foot);

  /* Same net app.js carries, for the same reason: IntersectionObserver does
     not fire in a hidden document, so a background-tab load that is already
     scrolled to the footer would leave the rail sitting over it. */
  function sweep() {
    const r = foot.getBoundingClientRect();
    setGone(r.top < innerHeight && r.bottom > 0);
  }
  addEventListener('visibilitychange', () => { if (!document.hidden) sweep(); });
  addEventListener('load', () => setTimeout(sweep, 1200));
}

})();


/* ============================================================
   nav mini cart — the slide-out behind the cart icon.

   Progressive enhancement over a real /cart link: with this file
   blocked, missing, or the AJAX cart unreachable (localhost has
   no Shopify behind it), the icon is still a working link to the
   cart page. Nothing here is load-bearing.

   Talks to Shopify's AJAX cart:
     GET  /cart.js          read
     POST /cart/change.js   set a line's quantity (0 = remove)
   Both are same-origin on the live store.

   Other bands: dispatch  new Event('hm:cart:open')  on document
   to open it (e.g. after an add-to-cart), and the drawer will
   re-fetch and show the fresh state.
   ============================================================ */
(() => {
'use strict';

const root   = document.getElementById('cartd');
const opener = document.querySelector('[data-cart-open]');
if (!root || !opener) return;

const panel  = root.querySelector('.cartd__panel');
const body   = root.querySelector('[data-cart-body]');
const foot   = root.querySelector('[data-cart-foot]');
const subEl  = root.querySelector('[data-cart-subtotal]');
const nEl    = root.querySelector('[data-cart-n]');
const badge  = document.querySelector('[data-cart-count]');

/* Money arrives in paise. Indian grouping, no paise shown when whole —
   which Shopify prices here always are. ₹ = ₹, kept as an escape so the
   file stays ASCII-safe wherever a host omits a charset. */
const money = (paise) => '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 0 });

const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

function paintBadge(count) {
  if (!badge) return;
  badge.hidden = !count;
  badge.textContent = count > 99 ? '99+' : String(count);
}

function render(cart) {
  paintBadge(cart.item_count);
  if (nEl) { nEl.hidden = !cart.item_count; nEl.textContent = '· ' + cart.item_count; }

  if (!cart.item_count) {
    body.innerHTML = '<p class="cartd__empty">Your cart is empty.</p>';
    foot.hidden = true;
    return;
  }

  body.innerHTML = cart.items.map((it) => `
    <div class="cartd__item" data-key="${esc(it.key)}">
      ${it.image ? `<img class="cartd__img" src="${esc(it.image)}" alt="" loading="lazy">` : '<span class="cartd__img"></span>'}
      <div>
        <p class="cartd__name">${esc(it.product_title)}</p>
        ${it.variant_title ? `<p class="cartd__variant">${esc(it.variant_title)}</p>` : ''}
        <span class="cartd__qty">
          <button type="button" data-q="${it.quantity - 1}" aria-label="Decrease quantity">&minus;</button>
          <span aria-label="Quantity">${it.quantity}</span>
          <button type="button" data-q="${it.quantity + 1}" aria-label="Increase quantity">+</button>
        </span>
      </div>
      <div>
        <p class="cartd__price">${money(it.final_line_price)}</p>
        <button type="button" class="cartd__rm" data-q="0">Remove</button>
      </div>
    </div>`).join('');

  subEl.textContent = money(cart.items_subtotal_price);
  foot.hidden = false;
}

async function fetchCart() {
  const r = await fetch('/cart.js', { credentials: 'same-origin' });
  if (!r.ok) throw new Error(r.status);
  return r.json();
}

async function setQty(key, q) {
  root.classList.add('is-busy');
  try {
    const r = await fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: q })
    });
    if (!r.ok) throw new Error(r.status);
    render(await r.json());
  } catch {
    /* One failed write must not strand a stale drawer — re-read. */
    try { render(await fetchCart()); } catch { /* keep what's shown */ }
  } finally {
    root.classList.remove('is-busy');
  }
}

body.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-q]');
  if (!btn) return;
  const item = btn.closest('[data-key]');
  if (item) setQty(item.dataset.key, Math.max(0, +btn.dataset.q));
});

/* ---- open / close ---- */
let restoreFocus = null;
let lastPad = '';

function lock() {
  /* The lock is inline (predates the porter's html.-passthrough fix; works,
     stays). The class is the CSS hook that hides the ChQMe embed while the
     drawer is open — its z-index outranks the scrim. See the CSS note. */
  const sbw = innerWidth - document.documentElement.clientWidth;
  lastPad = document.body.style.paddingRight;
  document.documentElement.style.overflow = 'hidden';
  if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
  document.documentElement.classList.add('cartd-open');
}
function unlock() {
  document.documentElement.style.overflow = '';
  document.body.style.paddingRight = lastPad;
  document.documentElement.classList.remove('cartd-open');
}

function open() {
  restoreFocus = document.activeElement;
  root.classList.add('open');
  root.setAttribute('aria-hidden', 'false');
  lock();
  root.querySelector('.cartd__close').focus();
  fetchCart().then(render).catch(() => {
    /* No AJAX cart here (localhost, or Shopify hiccup). The link the click
       came from is the fallback — follow it. */
    close();
    location.href = opener.href;
  });
}

function close() {
  if (!root.classList.contains('open')) return;
  root.classList.remove('open');
  root.setAttribute('aria-hidden', 'true');
  unlock();
  if (restoreFocus && document.contains(restoreFocus)) restoreFocus.focus();
}

opener.addEventListener('click', (e) => {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
  e.preventDefault();
  open();
});
document.addEventListener('hm:cart:open', open);

root.addEventListener('click', (e) => {
  if (e.target.closest('[data-cart-close]')) close();
});
addEventListener('keydown', (e) => {
  if (e.key === 'Escape') close();
  /* Minimal focus trap: Tab cycles inside the panel while it is open. */
  if (e.key === 'Tab' && root.classList.contains('open')) {
    const f = [...panel.querySelectorAll('a[href], button:not([disabled])')].filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
});

/* Badge on load: one small same-origin read. On localhost it fails and the
   badge simply stays hidden. Deferred so it never competes with the videos
   and images this page is actually about. */
if ('requestIdleCallback' in window) requestIdleCallback(() => fetchCart().then(render).catch(() => {}));
else setTimeout(() => fetchCart().then(render).catch(() => {}), 2500);

})();


/* ==== home-A/band-d.js ==== */
/* ============================================================
   BAND D — checkout accelerator hook for the mini cart.

   The home page sells nothing directly (every CTA is a link to a
   PDP or collection), but the nav mini cart can hold items added
   elsewhere, and its Checkout button must behave like the rest of
   the store: GoKwik one-page checkout by default, Razorpay Magic
   behind ?magic=1, native /checkout as the always-working
   fallback. Flags, entry points and fallback contract are copied
   from hydromax-A/band-d.js — see the annotations there. The
   layout renders gk-merchant-lite, so window.gokwikSdk and
   window.merchantInfo are present exactly as on hm/hu/hx.
   ============================================================ */
(() => {
'use strict';

const MAGIC_DEFAULT = false;
const GOKWIK_DEFAULT = true;

const q = new URLSearchParams(location.search);

const mFlag = q.get('magic');
let magicOn = MAGIC_DEFAULT;
try {
  if (mFlag === '1') localStorage.setItem('adivaa:magic', '1');
  else if (mFlag === '0') localStorage.removeItem('adivaa:magic');
  magicOn = MAGIC_DEFAULT || localStorage.getItem('adivaa:magic') === '1';
} catch (e) { magicOn = MAGIC_DEFAULT || mFlag === '1'; }
if (mFlag === '0') magicOn = false;

const gkFlag = q.get('gokwik');
let gokwikOn = GOKWIK_DEFAULT;
try {
  if (gkFlag === '1') localStorage.setItem('adivaa:gokwik', '1');
  else if (gkFlag === '0') localStorage.removeItem('adivaa:gokwik');
  gokwikOn = GOKWIK_DEFAULT || localStorage.getItem('adivaa:gokwik') === '1';
} catch (e) { gokwikOn = GOKWIK_DEFAULT || gkFlag === '1'; }
if (gkFlag === '0') gokwikOn = false;

function goMagic() {
  if (typeof window.openRzpLogin !== 'function') return false;
  try { window.openRzpLogin(); return true; } catch (e) { return false; }
}

function goKwik() {
  try {
    if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function' &&
        window.merchantInfo && window.merchantInfo.mid) {
      window.gokwikSdk.initCheckout(window.merchantInfo);
      return true;
    }
    if (typeof window.initiateLogin === 'function') {
      window.initiateLogin();
      return true;
    }
  } catch (e) { /* fall through to native */ }
  return false;
}

const accelOn = () => gokwikOn || magicOn;
const goAccel = () => (gokwikOn ? goKwik() : goMagic());

document.addEventListener('click', (e) => {
  if (!accelOn()) return;
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  if (!e.target.closest('.cartd__checkout')) return;
  /* Only swallow the native anchor if the accelerator actually opened. */
  if (goAccel()) e.preventDefault();
});

/* The drawer ships with Shopify's boilerplate "Shipping and taxes are
   calculated at checkout", which contradicts the store twice over: shipping
   is free across India and prices are MRP, taxes included. */
const note = document.querySelector('.cartd__note');
if (note) note.textContent = 'Free shipping across India. Price includes all taxes.';

/* ChQMe stands down at the footer, like the WhatsApp rail (band-a.js). The
   button loads late on its own schedule, so watch for it patiently. */
const foot = document.querySelector('.foot');
if (foot && 'IntersectionObserver' in window) {
  let atFoot = false;
  const dress = () => {
    const b = document.getElementById('chqme-widget-btn');
    if (b) b.classList.toggle('pg-at-foot', atFoot);
    return !!b;
  };
  new IntersectionObserver(([e]) => { atFoot = e.isIntersecting; dress(); }, { threshold: 0 }).observe(foot);
  let tries = 0;
  const t = setInterval(() => { if (dress() || ++tries > 40) clearInterval(t); }, 500);
}

})();

/* ==== site-A/site.js ==== */
/* ============================================================
   SITE — behaviour for the pg page system. Loaded after the home
   page's app.js (drawer, bubbles, progress), band-a.js (mini cart)
   and band-d.js (GoKwik on any .cartd__checkout click), so every
   checkout button here is simply a .cartd__checkout: the same
   accelerator flags and native fallback as the rest of the store.
   Each block no-ops when its markup is absent.
   ============================================================ */
(() => {
'use strict';

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- nav: mark the current section ---------- */
(() => {
  const path = location.pathname.replace(/\/$/, '') || '/';
  $$('#navlinks > a, #navlinks .nav__has-sub > a, .drawer__links > a').forEach((a) => {
    let u; try { u = new URL(a.href); } catch { return; }
    const p = u.pathname.replace(/\/$/, '') || '/';
    if (p === '/') return;
    const on = path === p || (p.startsWith('/blogs/') && path.startsWith('/blogs/')) ||
               (p.startsWith('/collections/') && path.startsWith('/collections/'));
    if (on) { a.classList.add('is-active'); a.setAttribute('aria-current', 'page'); }
  });
})();

/* ---------- contents list: build from headings, highlight in view ---------- */
(() => {
  const toc = $('[data-toc]');
  if (!toc) return;
  const scope = $(toc.dataset.toc) || document;
  let heads = $$('[data-toc-item]', scope);
  if (!heads.length) heads = $$('h2', scope);
  if (heads.length < 2) { (toc.closest('[data-toc-wrap]') || toc).hidden = true; return; }
  const list = toc.querySelector('ol');
  heads.forEach((h, i) => {
    if (!h.id) h.id = 's-' + (h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48) || i);
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.dataset.tocItem || h.textContent.replace(/^\d+\.\s*/, '').trim();
    li.appendChild(a); list.appendChild(li);
  });
  const links = $$('a', list);
  const io = new IntersectionObserver((es) => {
    es.forEach((e) => {
      if (!e.isIntersecting) return;
      links.forEach((l) => l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id));
    });
  }, { rootMargin: '-20% 0px -70% 0px' });
  heads.forEach((h) => io.observe(h));
})();

/* ---------- certificate lightbox ---------- */
(() => {
  const box = $('#lightbox');
  if (!box || typeof box.showModal !== 'function') return;
  const img = $('img', box), cap = $('[data-lb-cap]', box), open = $('[data-lb-open]', box);
  $$('[data-lb]').forEach((btn) => btn.addEventListener('click', () => {
    img.src = btn.dataset.lb; img.alt = btn.dataset.lbCap || '';
    cap.textContent = btn.dataset.lbCap || '';
    open.href = btn.dataset.lb;
    box.showModal();
  }));
  box.addEventListener('click', (e) => { if (e.target === box || e.target.closest('[data-lb-close]')) box.close(); });
})();

/* ---------- science: calm the radicals ---------- */
(() => {
  const wrap = $('[data-radicals]');
  if (!wrap) return;
  const out = $('[data-radicals-count]');
  let n = 0;
  $$('.radical', wrap).forEach((r) => r.addEventListener('click', () => {
    if (r.classList.contains('is-calm')) return;
    r.classList.add('is-calm'); r.textContent = 'H₂O'; r.setAttribute('aria-pressed', 'true');
    n += 1; if (out) out.textContent = n;
  }));
})();

/* ---------- science: play the reaction ---------- */
(() => {
  const rx = $('[data-reaction]');
  const btn = $('[data-reaction-play]');
  if (!rx || !btn) return;
  btn.addEventListener('click', () => {
    const on = rx.dataset.state === '1';
    rx.dataset.state = on ? '0' : '1';
    btn.textContent = on ? 'Play the reaction' : 'Reset';
  });
})();

/* ---------- counters on the science hero (reuse app.js tick look) ---------- */
(() => {
  const els = $$('[data-countup]');
  if (!els.length) return;
  const fmt = new Intl.NumberFormat('en-IN');
  const run = (el) => {
    const target = +el.dataset.countup;
    if (reduced) { el.textContent = fmt.format(target); return; }
    const t0 = performance.now();
    const step = (t) => {
      const p = Math.min((t - t0) / 1400, 1);
      el.textContent = fmt.format(Math.round(target * (1 - Math.pow(1 - p, 4))));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }), { threshold: .5 });
  els.forEach((el) => io.observe(el));
  addEventListener('load', () => setTimeout(() => els.forEach((el) => { if (el.textContent === '0') run(el); }), 1500));
})();

/* ---------- collection sort ---------- */
(() => {
  const sel = $('[data-sort]');
  if (!sel) return;
  sel.addEventListener('change', () => {
    const u = new URL(location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });
})();

/* ---------- share: copy link ---------- */
(() => {
  $$('[data-copy-link]').forEach((b) => b.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText(location.href.split('#')[0]); b.setAttribute('aria-label', 'Link copied'); b.title = 'Link copied'; } catch { /* no clipboard */ }
  }));
})();

/* ---------- AJAX cart helpers ---------- */
const post = async (url, body) => {
  const r = await fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
  return j;
};
const checkout = () => {
  /* The mini cart's Checkout anchor carries band-d's GoKwik hook and the
     native /checkout href underneath: clicking it is the one checkout path. */
  const a = $('.cartd__checkout');
  if (a) a.click(); else location.href = '/checkout';
};

/* ---------- slim product page ---------- */
(() => {
  const root = $('[data-pdp]');
  if (!root) return;

  const slides = $('.pdp__slides', root);
  const thumbs = $$('.pdp__thumbs button', root);
  if (slides && thumbs.length) {
    thumbs.forEach((t, i) => t.addEventListener('click', () => {
      slides.scrollTo({ left: slides.clientWidth * i, behavior: reduced ? 'auto' : 'smooth' });
    }));
    let raf = 0;
    slides.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(slides.scrollLeft / slides.clientWidth);
        thumbs.forEach((t, j) => t.setAttribute('aria-current', String(i === j)));
      });
    }, { passive: true });
  }

  const qtyOut = $('[data-pdp-qty]', root);
  let qty = 1;
  $$('[data-pdp-step]', root).forEach((b) => b.addEventListener('click', () => {
    qty = Math.max(1, Math.min(9, qty + +b.dataset.pdpStep));
    qtyOut.textContent = qty;
    $$('[data-pdp-step]', root).forEach((x) => { x.disabled = (+x.dataset.pdpStep < 0 && qty <= 1) || (+x.dataset.pdpStep > 0 && qty >= 9); });
  }));

  const msg = $('[data-pdp-msg]', root);
  const add = async (btn, then) => {
    if (msg) msg.hidden = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      await post('/cart/add.js', { items: [{ id: +root.dataset.variant, quantity: qty }] });
      then();
    } catch (e) {
      if (msg) { msg.textContent = e.message; msg.hidden = false; }
    } finally {
      btn.removeAttribute('aria-busy');
    }
  };
  $$('[data-pdp-add]', root).forEach((b) => b.addEventListener('click', () => add(b, () => document.dispatchEvent(new Event('hm:cart:open')))));
  $$('[data-pdp-buy]', root).forEach((b) => b.addEventListener('click', () => add(b, checkout)));
})();

/* ---------- cart page ---------- */
(() => {
  const page = $('[data-cartpage]');
  if (!page) return;
  const change = async (key, quantity) => {
    page.classList.add('is-busy');
    try { await post('/cart/change.js', { id: key, quantity }); } catch { /* reload shows the truth */ }
    location.reload();
  };
  page.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-q]');
    if (!b) return;
    const line = b.closest('[data-line]');
    change(line.dataset.line, Math.max(0, +b.dataset.lineQ));
  });
  $$('[data-cart-checkout]', page).forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); checkout(); }));
})();

})();
